export enum PopupMessageType {
    ErrorAlert,
    SucceedAlert,
    SnackBar,
}
export class PopupMessage {
    constructor(public message:string, public type:PopupMessageType) {}
}